import { Row, Typography } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import _ from 'lodash';
import React from 'react';
import styled from 'styled-components';

import { useTranslation } from 'react-i18next';
import { extractDoc } from '../../../../services/ML/DataExtraction/extractDoc';
import { DocTypes, PaymentConfirmation } from '../../../../services/ML/docTypes';
import { useAppDispatch } from '../../../../store';
import { OcrItem, ocrItemRemoved, ocrItemSelected, ocrItemUpdated } from '../../../../store/impOcr';
import { RowMd } from '../../../../styles';
import { formatDate } from '../../../../utils/helpers/date';
import EvidCard from '../EvidCard';
import { EvidCardItem } from '../EvidCardItem';

const { Text } = Typography;

const PayConEvidCard = ({
  ocrItem,
  index,
  setSelected,
  selectedItems,
  onMerge,
  isSelected
}:{
  ocrItem: OcrItem
  index: number,
  setSelected:(selectedItems: number[]) =>void
  selectedItems: number[],
  onMerge: (clickedIndex: number) => void
  isSelected: boolean,
}) => {
  const dispatch = useAppDispatch();


  const { t } = useTranslation();

  const {
    correctedDocResults,
    pages,
    correctedDocType,
    doc
  } = ocrItem;

  const results = correctedDocResults as PaymentConfirmation;

  const {
    paymentDate,
    paymentSum,
    createDate,
    paymentTitle,
  } = results;

  const onDelete = () => {
    dispatch(ocrItemRemoved(index));
  };

  const onEdit = () => {
    dispatch(ocrItemSelected(index));
  };

  const onDocTypeChange = (dt: DocTypes) => {
    const extractedData = extractDoc(doc, dt);
    dispatch(ocrItemUpdated({
      ocrItem:{
        ...ocrItem,
        correctedDocType: dt,
        extractedData,
        docResults: extractedData,
        correctedDocResults: extractedData,
      },
      index
    }));
  };

  const onMergeClick = () => {
    onMerge(index);
  };

  const onSelect = (e: CheckboxChangeEvent) => {
    if ( e.target.checked && !isSelected) {
      setSelected([
        ...selectedItems,
        index
      ]);
    }
    if (!e.target.checked && isSelected) {
      const cloned = _.cloneDeep(selectedItems).filter(v =>
        v !== index);
      setSelected(cloned);
    }
  };

  return (
    <EvidCard
      {...{
        image: pages[0].image ?? '',
        onDelete,
        onMerge: onMergeClick,
        onEdit,
        pages:pages.length,
        subtitle:createDate ? `${t('PayConEvidCard.dated')} ${createDate}` : '',
        title: t('PayConEvidCard.confirmation'),
        docType: correctedDocType,
        onDocTypeChange,
        onSelect,
        checked:isSelected,
        mergeDisabled: selectedItems.length === 0 || isSelected
      }}
    >
      <>
        <Row>
          <EvidCardItem
            title={t('PayConEvidCard.amount')}
            value={paymentSum ? `${paymentSum.toFixed(2)} zł` : '0 zł'}
          />
          <EvidCardItem
            title={t('PayConEvidCard.paymentDate')}
            value={paymentDate ? formatDate(paymentDate) : t('NoData')}
          />
        </Row>
        <RowMd>
          <Text type='secondary'>{t('PayConEvidCard.title')}</Text>
          <TextStyled strong>{paymentTitle ?? t('NoData')}</TextStyled>
        </RowMd>
      </>
    </EvidCard>
  );
};

export default PayConEvidCard;

const TextStyled  = styled(Text)`
  padding-left: 12px;
  font-size: 500;
`;


export const createPayConTitle = () => {
  return 'Potwierdzenie wpłaty';
};